export default "__VITE_ASSET__D1xFJn0J__"